import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { adminApi, errMsg } from "@/lib/api";

const Field = ({ label, ...p }) => (
  <>
    <label className="block text-xs font-bold uppercase tracking-wider text-stone-500 mt-4 mb-1">{label}</label>
    <Input className="h-11" {...p} />
  </>
);

export const ForgotPassword = ({ onDone }) => {
  const [step, setStep] = useState("email");
  const [f, setF] = useState({ email: "", code: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: k === "code" ? e.target.value.replace(/\D/g, "").slice(0, 6) : e.target.value });

  const call = async (fn) => {
    setBusy(true); setError("");
    try { await fn(); } catch (er) { setError(errMsg(er)); } finally { setBusy(false); }
  };
  const sendCode = (e) => { e.preventDefault(); call(async () => { await adminApi.post("/auth/forgot", { email: f.email }); setStep("code"); }); };
  const reset = (e) => {
    e.preventDefault();
    call(async () => {
      await adminApi.post("/auth/reset", { email: f.email, code: f.code, new_password: f.new_password });
      toast.success("Password changed. Please sign in with your new password.");
      onDone();
    });
  };

  return (
    <form onSubmit={step === "email" ? sendCode : reset} data-testid="forgot-password-form">
      <h2 className="font-display text-2xl text-primary font-semibold mt-2">Reset password</h2>
      {error && <p className="mt-3 text-sm text-accent bg-accent/10 rounded-md p-3" data-testid="forgot-error">{error}</p>}
      {step === "email" ? (
        <>
          <p className="text-sm text-stone-500 mt-1">We'll send a 6-digit code to the admin email (and WhatsApp once it's set up).</p>
          <Field label="Admin email" type="email" value={f.email} onChange={set("email")} data-testid="forgot-email" />
          <button disabled={busy || !f.email} className="mt-6 w-full h-11 rounded-md bg-primary text-white font-semibold disabled:opacity-50" data-testid="forgot-send-code">{busy ? "Sending…" : "Send code"}</button>
        </>
      ) : (
        <>
          <p className="text-sm text-stone-500 mt-1" data-testid="forgot-code-sent">If {f.email} is the admin email, a code is on its way. Check your inbox (and spam).</p>
          <Field label="6-digit code" inputMode="numeric" value={f.code} onChange={set("code")} data-testid="forgot-code" />
          <Field label="New password (min 8)" type="password" autoComplete="new-password" value={f.new_password} onChange={set("new_password")} data-testid="forgot-new-password" />
          <Field label="Repeat new password" type="password" autoComplete="new-password" value={f.confirm} onChange={set("confirm")} data-testid="forgot-confirm-password" />
          {f.confirm && f.confirm !== f.new_password && <p className="text-xs text-accent mt-1" data-testid="forgot-mismatch">Passwords don't match.</p>}
          <button disabled={busy || f.code.length !== 6 || f.new_password.length < 8 || f.confirm !== f.new_password} className="mt-6 w-full h-11 rounded-md bg-primary text-white font-semibold disabled:opacity-50" data-testid="forgot-reset-btn">{busy ? "Saving…" : "Set new password"}</button>
          <button type="button" onClick={(e) => sendCode(e)} disabled={busy} className="mt-3 text-sm text-primary underline" data-testid="forgot-resend">Send a new code</button>
        </>
      )}
      <button type="button" onClick={onDone} className="mt-4 block text-sm text-stone-500 hover:text-primary" data-testid="forgot-back-to-login">← Back to sign in</button>
    </form>
  );
};
